import React from "react";
import { Form, Col, Row } from "antd";
import { useSelector } from "react-redux";
import Scrollbar from "../../tools/common/Scrollbar";
import i18n from "i18next";
import {
  FaCircle,
  FaCircleNotch,
  FaExclamationCircle,
  FaCheck,
} from "react-icons/fa";
import { tMapEditorMap } from "../../../assets/libs/i18n/translator";

const MapPropertiesPanel = ({
  validation: { duplicates, notCategorized, unlabeled, numberSeats },
}) => {
  const { categories } = useSelector((state) => state.properties);

  const properties = {
    categories,
    numberSeats,
    duplicates: duplicates.length,
    notCategorized: notCategorized.length,
    unlabeled: unlabeled.length,
  };

  return (
    <Scrollbar>
      <Form layout="horizontal">
        <ul className="rde-ul">
          <li>
            <Row>

              <Col span={24}>
                <h3 className="text-center">
                  {i18n.t("mapeditor.map.title")}
                </h3>
              </Col>

              <Col span={24}>
                <ul className="rde-default-list">
                  {properties.numberSeats > 0 ? (
                    <li>
                      <FaCircle className="mr-2" />{" "}
                      {`${properties.numberSeats} ${properties.numberSeats === 1 ? tMapEditorMap("place") : tMapEditorMap("places")}`}
                    </li>
                  ) : (
                    <li className="text-warning">
                      <FaExclamationCircle className="mr-2" />{" "}
                      {i18n.t("mapeditor.map.not-places")}
                    </li>
                  )}
                  {Array.isArray(properties.categories) && properties.categories.length > 0 ? (
                    <li>
                      <FaCircleNotch className="mr-2" />{" "}
                      {`${properties.categories.length} ${properties.categories.length === 1 ? tMapEditorMap("category") : tMapEditorMap("categories")}`}
                    </li>
                  ) : (
                    <li className="text-warning">
                      <FaExclamationCircle className="mr-2" />{" "}
                      {tMapEditorMap("not-categories")}
                    </li>
                  )}
                  {properties.numberSeats > 0 && (
                    <>
                      {properties.duplicates > 0 ? (
                        <li className="text-warning">
                          <FaExclamationCircle className="mr-2" />{" "}
                          {`${properties.duplicates} ${properties.duplicates === 1 ? tMapEditorMap("duplicate-place") : tMapEditorMap("duplicate-places")}`}
                        </li>
                      ) : (
                        <li className="text-success">
                          <FaCheck className="mr-2" />{" "}
                          {i18n.t("mapeditor.map.not-duplicate-places")}
                        </li>
                      )}
                      {properties.unlabeled > 0 ? (
                        <li className="text-warning">
                          <FaExclamationCircle className="mr-2" />{" "}
                          {`${properties.unlabeled} ${properties.unlabeled === 1 ? tMapEditorMap("unlabeled-place") : tMapEditorMap("unlabeled-places")}`}
                        </li>
                      ) : (
                        <li className="text-success">
                          <FaCheck className="mr-2" />{" "}
                          {tMapEditorMap("all-places-labeled")}
                        </li>
                      )}
                      {properties.notCategorized > 0 ? (
                        <li className="text-warning">
                          <FaExclamationCircle className="mr-2" />{" "}
                          {`${properties.notCategorized} ${properties.notCategorized === 1 ? tMapEditorMap("not-categories-place") : tMapEditorMap("not-categories-places")}`}
                        </li>
                      ) : (
                        <li className="text-success">
                          <FaCheck className="mr-2" />{" "}
                          {tMapEditorMap("all-places-categorized")}
                        </li>
                      )}
                    </>
                  )}
                </ul>
              </Col>
            </Row>
          </li>
        </ul>
      </Form>
    </Scrollbar>
  );
};

export default MapPropertiesPanel;